const Footer = () => (
  <footer className="bg-gray-900/50 border-t border-gray-700/50 text-gray-400 py-8 mt-20">
    <div className="max-w-7xl mx-auto px-6">
      <div className="flex flex-col md:flex-row items-center justify-between gap-4">
        <div className="flex items-center gap-2">
          <div className="w-6 h-6 bg-gradient-to-r from-blue-500 to-green-500 rounded-lg flex items-center justify-center">
            <span className="text-white font-bold text-xs">K</span>
          </div>
          <span className="text-white font-medium">Kallisto</span>
        </div>
        
        <div className="flex items-center gap-6 text-sm">
          <a href="/privacy" className="hover:text-white transition-colors">Privacy</a>
          <a href="/terms" className="hover:text-white transition-colors">Terms</a>
          <a href="mailto:sergii.kozyrev@kallisto.dev" className="hover:text-white transition-colors">
            Contact
          </a>
        </div>
        
        <p className="text-sm">
          &copy; {new Date().getFullYear()} Kallisto — All rights reserved
        </p>
      </div>
    </div>
  </footer>
);

export default Footer;
